export default {
    en: {
        pageTitle: "Responsive design in all devices"
    },
    es: {
        pageTitle: "Adaptable en todos los dispositivos"
    },
    ko: {
        pageTitle: "Konsepsyon repons nan tout aparèy"
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/health-care-book/responsive/responsive.language.js
// module id = 633
// module chunks = 0